export default "__VITE_ASSET__C4PH6nKb__"